module.exports = __webpack_public_path__ + "static/media/apercu-bold-pro.1679b8a4.woff";